import * as React from "react";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import ConfirmButton from "src/common/components/ui/ConfirmButton";
import { AWSStatusRaw } from "src/domain/core/workflow/components/active/Status";

const useStyles = makeStyles(() => ({
  button: {
    width: "15px",
    padding: "0px",
    marginBottom: "5px",
    fontSize: "10px",
    float: "right",
  },
  flash: {
    animation: `$flashing 2.5s linear infinite`,
  },
  "@keyframes flashing": {
    "50%": {
      opacity: 0.3,
    },
  },
}));

interface WorkflowControlButtonProps {
  workflowName: string;
  status: string;
  diskName: string;
  deleteDisabled: boolean;
  updateDisabled: boolean;
  updateClick: () => Promise<void>;
  deleteClick: () => Promise<void>;
}

function isWorkflowPending(workflowStatus): boolean {
  switch (workflowStatus) {
    case AWSStatusRaw.CREATE_IN_PROGRESS:
      // case AWSStatusRaw.UPDATE_IN_PROGRESS:
      return true;
    default:
      return false;
  }
}

const ButtonGrp = styled("div")(() => ({
  maxWidth: "75px",
}));

export const WorkflowControlButtons: React.FC<WorkflowControlButtonProps> = ({
  workflowName,
  status,
  diskName,
  deleteDisabled,
  updateDisabled,
  updateClick,
  deleteClick,
}) => {
  const classes = useStyles();
  const [aborting, setAborting] = React.useState(false);

  if (isWorkflowPending(status) || aborting) {
    return (
      <ButtonGrp>
        <ConfirmButton
          className={classes.button}
          showModalFunc={() => true}
          confirmText={
            <p>Are you sure? This action will terminate the workflow. (You may create a new workflow at any time.)</p>
          }
          confirmButtonText="Yes"
          loading={aborting}
          loadingIndicator="Aborting..."
          type="submit"
          variant="outlined"
          color="error"
          onSubmit={async () => {
            setAborting(true);
            deleteClick();
          }}
          sx={{
            minWidth: "75px",
          }}
        >
          Abort
        </ConfirmButton>
      </ButtonGrp>
    );
  }

  return (
    <ButtonGrp>
      <Button
        className={classes.button}
        disabled={updateDisabled}
        variant="outlined"
        sx={{
          minWidth: "75px",
        }}
        onClick={updateClick}
      >
        Update
      </Button>

      <ConfirmButton
        data-testid={`${workflowName}-shutdown`}
        className={classes.button}
        disabled={deleteDisabled}
        showModalFunc={() => true}
        confirmText={
          <p>
            Running analyses will be terminated. Your work will be saved to disk: <strong>{diskName}</strong>. Are you
            sure you want to shutdown?
          </p>
        }
        confirmButtonText="Yes"
        loadingIndicator="Shutting Down..."
        type="submit"
        variant="outlined"
        color="error"
        onSubmit={deleteClick}
        sx={{
          minWidth: "75px",
        }}
      >
        Shut down
      </ConfirmButton>
    </ButtonGrp>
  );
};
